"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
const LayoutColumn = ({
  as: Component = "div",
  children,
  dataTest,
  spanEntireRow
}) => {
  return (
    /*#__PURE__*/
    // @ts-expect-error allow any component passed as string (TODO change the prop type to React.ElementType to fix this error)
    React.createElement(Component, {
      className: (0, _clsx.default)("max-lm:[&_.orbit-card]:-mx-400 max-lm:[&_.orbit-card]:w-auto", spanEntireRow && "col-span-full"),
      "data-test": dataTest
    }, children)
  );
};
var _default = exports.default = LayoutColumn;